import { useLocation, useHistory } from "react-router";
import qs from "web/core/utils/queryString";
import { useCallback } from "react";
import useOptions from "./useOptions";
import makeQueryFromLocation from "theme/modules/Layer/makeQueryFromLocation";

const useLayerSorting = (value) => {
  const location = useLocation();
  const history = useHistory();

  const options = useOptions();

  const query = makeQueryFromLocation(location);
  if (!value) {
    value = {
      sort: JSON.stringify(query.params?.sort),
      pageLength: query.params?.size,
    };
  }

  const sortAction = useCallback(
    ({ sort, pageLength }) => {
      const { pathname, search } = location;
      const previousSearch = qs.parse(search);
      let shouldUpdate = false;
      let query = { ...previousSearch };
      if (previousSearch.sort !== sort) {
        shouldUpdate = true;
        query.sort = sort || undefined;
      }
      if (previousSearch.pageLength !== pageLength) {
        shouldUpdate = true;
        query.pageLength = pageLength;
      }

      if (shouldUpdate) {
        const updatedSearch = qs.stringify(query);
        history.push({
          pathname,
          search: updatedSearch,
        });
      }
    },
    [history, location]
  );

  return [
    options,
    {
      sort: value ? value.sort : undefined,
      pageLength: value ? value.pageLength : undefined,
    },
    sortAction,
  ];
};

export default useLayerSorting;
